import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import ArrowRightTwoToneIcon from '@mui/icons-material/ArrowRightTwoTone';
import CapsoIcon from './UI/CapsoIcon';

const StatusSequence = ({curStatus}) => {
	const statusSequenceArr = ['ingested', 'in transit', 'received and in process', 'reader reviewing', 'report signed'];


	const StatusIconArr = statusSequenceArr.map((status) => {
		return (
			<Box key={status} >
				<CapsoIcon iconName={`status-${status.split(' ').join('')}`} grey={curStatus !== status} size="lg" />
			</Box>
		)
	})

	const renderArrow = () => {
		return (
			<Box>
				<ArrowRightTwoToneIcon />
			</Box>
		)
	}

	return (
		<Box sx={{ mt: 'auto' }}>
			<Divider variant="light" />
			<Stack direction="row" divider={renderArrow()} spacing={2} alignItems="center" justifyContent="center" sx={{ pt: 2 }}>
				{ StatusIconArr }
			</Stack>
		</Box>
	)
}

export default StatusSequence;